import Vue from 'vue'
import {
  bus
} from '@/libs/bus'
import {
  utils
} from "@/libs/utils";

import errors from '@/rules/errors'
import debug from 'debug'
var debug_menuCommon = debug("esma:menu_common")
import acl from '@/rules/acl_rules'

export default {
  created: function () {},
  data() {
    return {
      user_type: 0
    }
  },
  computed: {
    acl(){
      return utils.acl;
    },
    permissionMode(){
      return utils.PERMISSION_MODE;
    }
  },
  mounted() {
    this.user_type = parseInt(Vue.localStorage.get('userType'));
  },
  methods: {
    checkMenuUserPermission(page_acl, permission = utils.PERMISSION_MODE.BROWSE,requester=""){
      return utils.check_user_permission(page_acl,permission,requester)
    },
    resetMenuUserPermission(){
      return utils.reset_user_permissions()
    },
    allowMenuItemAsString(arr) {
      var ret = "false";
      arr.forEach(name => {
        debug_menuCommon("allowMenuItem", this.user_type, acl[name].browse.indexOf(this.user_type) > -1, name, acl[name])
        if (acl[name].browse.indexOf(this.user_type) > -1) {
          ret = "true"
        }
      });
      debug_menuCommon("allowMenuItem return ", ret)
      return ret;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/mixin_menu_common.js